import html2pdf from "html2pdf.js";
export const generatePdf = (options = {}) => {
    const {
        selector = '.toPdf',
        filename = 'document.pdf',
        margin = 0.3,
        scale = 2,
        openInNewTab = true,
        showToast = null,
        applyStyles = true // New option to control style application
    } = options;

    const contentElement = document.querySelector(selector);
    if (!contentElement) {
        if (showToast) {
            showToast({}, "No content found to export.");
        }
        console.error('PDF generation error: No content element found');
        return Promise.reject('No content element found');
    }

    // Clone the element to avoid affecting the original DOM
    const clonedElement = contentElement.cloneNode(true);
    
     // Apply PDF-specific styles only if requested
    if (applyStyles) {
        applyPdfStyles(clonedElement);
    }

    // PDF options
    const pdfOptions = {
        margin: margin,
        filename: filename,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { 
            scale: scale,
            useCORS: true,
            logging: false
        },
        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
    };

    // Generate PDF
    return html2pdf()
        .from(clonedElement)
        .set(pdfOptions)
        .outputPdf('bloburl')
        .then((pdfUrl) => {
            if (openInNewTab) {
                window.open(pdfUrl, '_blank');
            }
            return pdfUrl;
        });
};

// Reusable style application function
export const applyPdfStyles = (element) => {
    // Add PDF-specific styles with reduced spacing
    element.querySelectorAll('.text-900.font-medium').forEach(el => {
        el.style.whiteSpace = 'nowrap';
        el.style.display = 'inline';
        el.style.margin = '0';
        el.style.padding = '0';
    });
    
    element.querySelectorAll('.surface-border.flex').forEach(el => {
        el.style.flexWrap = 'nowrap';
        el.style.padding = '1px 0';
        el.style.margin = '1px 0';
    });

    element.querySelectorAll('.font-bold').forEach(el => {
        el.style.margin = '0';
        el.style.padding = '0';
    });

    element.querySelectorAll('span').forEach(el => {
        el.style.margin = '0';
        el.style.padding = '0';
    });

    // Reduce gap between flex items
    element.querySelectorAll('.gap-3').forEach(el => {
        el.style.gap = '0.5rem';
    });

    return element;
};

